import React from 'react'
import constants from 'common/helpers/constants'
import cx from 'classnames'

import OffersItem from './OffersItem/OffersItem'
import type { OffersItemProps } from './OffersItem/OffersItem'

import s from './Offers.scss'


type Item = {
  size: number
  price: string
  save?: string
  // "title" and "planName" props need for onChoose func.
  // "title" used in pages/profile/UpgradeSubscriptionPage
  // "planName" used in modals/prepaidCard/PrepaidCardWithSubscriptionPlansModal
  title?: string
  planName?: string
}

type OffersProps = {
  className?: string
  itemClassName?: string
  items: Item[]
  bestSize?: number
  selectedIndex?: number
  offerTitle?: OffersItemProps['offerTitle']
  placement?: string
  onChoose: OffersItemProps['onChoose']
}

const Offers: React.FunctionComponent<OffersProps> = (props) => {
  const { className, itemClassName, items, bestSize, selectedIndex, offerTitle, placement, onChoose } = props

  return (
    <div
      className={cx(s.container, className)}
      role="list"
      data-testid="offers"
    >
      {
        items.map(({ price, size, title, planName, save: discount }, index) => {
          const isSelected  = selectedIndex === index
          const isBest      = size === bestSize && !isSelected
          const buttonId    = placement && `${placement}${index}Button`

          const className = cx(s.item, itemClassName, {
            [s.odd]: Boolean(items.length % 2),
          })

          const itemProps = {
            price,
            size,
            discount,
            title,
            planName,
            offerTitle,
            buttonId,
            isBest,
            isSelected,
            onChoose,
          }

          return (
            <div key={index} className={className} role="listitem">
              <OffersItem {...itemProps} />
            </div>
          )
        })
      }
    </div>
  )
}


export default Offers
